import './helpers-d639255d.js';
import { b as registerComponent, u as use } from './plugins-4295ce0e.js';
import './Icon-9c764942.js';
import { _ as __vue_component__, a as __vue_component__$1 } from './Pagination-70e0ba98.js';
export { _ as OPagination, a as OPaginationButton } from './Pagination-70e0ba98.js';

var Plugin = {
  install: function install(Vue) {
    registerComponent(Vue, __vue_component__);
    registerComponent(Vue, __vue_component__$1);
  }
};
use(Plugin);

export default Plugin;
